define(function(require) {
    var $ = require("jquery");

    function highlightConfirmAccountFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error:visible').each(function (index, element) {
            $(element).parent().parent().addClass('is-error');
        });
    }

    function undoConfirmAccountFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error').each(function (index, element) {
            $(element).parent().parent().removeClass('is-error');
        });
    }

    function createValidationSummary() {
        $('div.validation-summary-errors').remove();
        var errorMessages = $('span.field-validation-error:visible').map(function () {
            return $.trim($(this).text());
        }).get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        var errorMessageCount = $(errorMessages).length;
        var $header = $('div.edit-account');
        var listHtml = "";
        $header.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong class='form-error-text'>" + errorMessageCount + $('.hidden.validation-error-count').html() + "</strong>";
        listHtml += "<ul>";
        $(errorMessages).each(function (index, element) {
            listHtml += ("<li>" + element + "</li>");
        });
        listHtml += "</ul>";
        $(listHtml).appendTo('#javascriptValidationSummary');
    }

    undoConfirmAccountFieldHighlights();
    highlightConfirmAccountFields();

    $('#confirmAccountButton').click(function(e) {
        e.preventDefault();

        undoConfirmAccountFieldHighlights();

        $('span.field-validation-error.form-error-hint').hide();

        var isValid = true;

        var password = $('#password').val();

        if (!password) {
            isValid = false;
            $('#passwordError').show();
        }

        if (isValid) {
            undoConfirmAccountFieldHighlights();
            $('javascriptValidationSummary').remove();
            $('form#editAccountGateForm').submit();
        } else {
            highlightConfirmAccountFields();
            createValidationSummary();
            $('html,body').animate({ scrollTop: 0 }, 'slow');
        }
    });
});
